import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import NavigationBtns from "./Navigation-btns";

const Introduction = () => {
  return (
    <div
      className="introduction "
      data-aos="fade-right"
      data-aos-delay="300"
      data-aos-duration="1000"
    >
      <div className="alert alert-primary mb-5" role="alert">
        <div className="mb-2">
          <AiOutlineInfoCircle size={22} /> <strong>INFO</strong>
        </div>
        Keep /configs/credential.php and /configs/init.php file while updating.
        If you don’t keep them, you may have a problem with lisence.
      </div>

      <h1 className="title">Introduction</h1>

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a href="https://uzmart.org" target="_blank" className="strong">
          {" "}
          Website
        </a>
      </strong>
      <br />

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a href="https://admin.uzmart.org" target="_blank" className="strong">
          {" "}
          Admin panel
        </a>
      </strong>
      <br />

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a
          href="https://testflight.apple.com/join/qlRpaL76"
          target="_blank"
          className="strong"
        >
          {" "}
          IOS Customer app
        </a>
        ,
        <a
          href="https://play.google.com/store/apps/details?id=org.uzmart"
          target="_blank"
          className="strong"
        >
          {" "}
          Android Customer app
        </a>
      </strong>
      <br />

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a
          href="https://testflight.apple.com/join/ZjHulxhx"
          target="_blank"
          className="strong"
        >
          {" "}
          IOS Seller app{" "}
        </a>
        ,
        <a
          href="https://play.google.com/store/apps/details?id=uzmart.seller"
          target="_blank"
          className="strong"
        >
          {" "}
          Android Seller app
        </a>
      </strong>
      <br />

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a
          href="https://testflight.apple.com/join/yRkN7RZE"
          target="_blank"
          className="strong"
        >
          {" "}
          IOS Driver app{" "}
        </a>
        ,
        <a
          href="https://play.google.com/store/apps/details?id=uzmart.driver"
          target="_blank"
          className="strong"
        >
          {" "}
          Android Driver app
        </a>
      </strong>
      <br />

      <strong className="introduction-subTitle">
        Build Your Business with our -
        <a
          href="https://testflight.apple.com/join/UzjRy3Hr"
          target="_blank"
          className="strong"
        >
          {" "}
          IOS Pos app{" "}
        </a>
        ,
        <a
          href="https://play.google.com/store/apps/details?id=org.uzmart.pos"
          target="_blank"
          className="strong"
        >
          {" "}
          Android Pos app
        </a>
      </strong>
      <br />
      <br />

      <div>
        Uzmart is a multi vendor digital product, full solution ( apps, web,
        admin) developed by applying Laravel, React Js , Next Js and Flutter
        Frameworks. <br />
        Laravel is an open-source PHP Framework intended for the development of
        web applications which is a complete toolset, robust, yet easy to
        understand with an excellent, expressive syntax. <br />
        Next.js is an open-source web development framework created by Vercel
        enabling React-based web applications with server-side rendering and
        generating static websites.
        <br />
        React (also known as React.js or ReactJs) is a free and open-source
        front-end JavaScript library[3] for building user interfaces based on UI
        components.
        <br />
        Flutter is an open-source framework for mobile application development
        created by Google. It is applied to develop multi-platform, natively
        compiled applications for Android and iOS.
        <div className="line-break" />
        Uzmart consists of 2 Mobile Applications, 5 Web Panel, 1 website:
        <br />
        <div className="introduction-img-container">
          <SimpleReactLightbox>
            <SRLWrapper>
              <a
                href="/assets/img/doc/uzmart-admin-banner.png"
                data-fancybox
                rel="nofollow"
              >
                <img
                  src="/assets/img/doc/uzmart-admin-banner.png"
                  alt="admin"
                  loading="lazy"
                  className="img-responsive-full"
                />
              </a>
            </SRLWrapper>
          </SimpleReactLightbox>
          <SimpleReactLightbox>
            <SRLWrapper>
              <a href="/assets/img/project/18.png" data-fancybox rel="nofollow">
                <img
                  src="/assets/img/project/18.png"
                  alt="web main"
                  loading="lazy"
                  className="img-responsive-full"
                />
              </a>
            </SRLWrapper>
          </SimpleReactLightbox>
        </div>
        <div className="line-break" />
        <h3 className="introduction-contentTitle">
          3 Apps developed using Flutter
        </h3>
        • Customer application <br />
        • Delivery Boy application (not included) <br />
        • Manager application (not included) <br />
        <h3 className="introduction-contentTitle">
          5 web panel developed using Laravel & React Js
        </h3>
        • Admin web panel
        <br />
        • Manager web panel <br />
        • Store web panel <br />
        • Moderator web panel <br />
        • Delivery boy web panel <br />
        <h3 className="introduction-contentTitle">
          1 web site developed using Typescript & Next Js
        </h3>
        • Customer web site <br />
        <div className="line-break" />
      </div>

      <NavigationBtns />
    </div>
  );
};

export default Introduction;
